import Skeleton from 'react-loading-skeleton';

const DynamicHotelDetailsSkeleton = () => {
  return (
    <div className={'dyn-hotel'}>
      <div className="dyn-hotel-img">
        <Skeleton height={'100%'} width={'100%'} />
      </div>
      <div className="dyn-hotel-info">
        <div className="text-bold text-md">
          <Skeleton height={25} width={'50%'} />
        </div>
        <Skeleton width={'50%'} />
        <Skeleton width={'55%'} />
        <div className="text-bold">
          <Skeleton width={120} />
        </div>
        <div>
          <Skeleton width={130} />
        </div>
        <div>
          <Skeleton width={100} />
        </div>
        <div className="dyn-hotel-actions">
          <Skeleton width={'100%'} />
        </div>
      </div>
      <div className="flex-center flex-one display-column">
        <Skeleton width={100} height={38} />
      </div>
    </div>
  );
};

export default DynamicHotelDetailsSkeleton;
